<template>
  <div class="_UsageReports-BlankView">
    <div class="_UsageReports-BlankView-Content">
      <CIcon material name="bar_chart" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CIcon from '@/components/uikit/CIcon';

const messages = {
  en: {},
  ja: {},
};

export default Vue.extend({
  name: 'BlankView',
  i18n: { messages },
  components: { CIcon },
});
</script>

<style lang="scss" scoped>
._UsageReports-BlankView {
  height: 100%;

  &-Content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 300px;
    color: $neutral-secondary-color;
    opacity: 0.5;
  }
}
</style>
